import { AfterViewInit, Component, TemplateRef, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ThemeService } from 'src/app/service/theme.service';
import { AlertService } from 'src/app/service/alert.service';
import { CommonService } from 'src/app/service/common.service';
import { DataService } from 'src/app/service/data.service';
import { UserMenuComponent } from '../userMenuModule/user-menu.component';
import { RoService } from 'src/app/service/ro.service';

@Component({
	selector: 'eulaPopup',
	templateUrl: './eulaPopup.component.html',
	styleUrls: ['./eulaPopup.component.scss']
})

export class EulaPopupComponent implements AfterViewInit {

	@ViewChild('customEleTemplate') private customEleTemplate!: TemplateRef<HTMLDivElement>;
	@ViewChild('userMenu') private userMenu!: UserMenuComponent;
	private isChecked: boolean = false;
	private isShowingEulaPopup: boolean = false;
	private okaEulaVer: number = 1779256154;

	constructor(public translate: TranslateService, public themeService: ThemeService, private als: AlertService, private coms: CommonService, public datas: DataService, private ros: RoService) {
	}

	ngAfterViewInit(): void {
		this.datas.jwt$.subscribe(() => {
			if (!this.isChecked) { // "isChecked"避免因轉jwt而多次重複檢查
				this.checkNeedShowAiAgreement();
				this.isChecked = true;
			}
		});
	}


	//-------------------------------------------------------------------------------------------------
	private checkNeedShowAiAgreement(delaySec: number = 15): void {
		if (this.isShowingEulaPopup) return;
		const checkLater: Function = () => { //如果有error，就15, 30, 60,...秒後再檢查
			setTimeout(() => this.checkNeedShowAiAgreement(delaySec * 2), delaySec * 1000);
		}

		this.coms.waitFor(() => this.datas.jwt, 10, 1000).then(() => {
			this.datas.post2({ data: { api: 'Account.getUpdateSetting', json: [] } }).then((res: any) => {

				if (!res.account.personalSettings) {
					this.showEulaPopup();
				} else {
					try {
						let ps: any = JSON.parse(res.account.personalSettings);
						if (!ps.okaEulaVer || ps.okaEulaVer < this.okaEulaVer) {
							this.showEulaPopup();
						}
					} catch (e) {
						checkLater();
					}
				}
			});
		}).catch(() => {
			checkLater();
		});
	}

	public openUrl(url: string): void {
		if (this.datas.isInWeb) {
			window.open(url, '_blank');
		} else {
			this.ros.request('openExternalBrowser', url);
		}
	}

	public showEulaPopup(): void {
		this.isShowingEulaPopup = true;
		this.coms.waitFor(() => this.customEleTemplate && this.datas.getLang()).then(() => {
			const lang: string = this.datas.getLang() || "tc";
			this.als.alert2(undefined, null, {
				btns: [[
					{ key: "agree", label: { tc: "同意", sc: "同意", en: "Agree" }[lang], ngStyle: { backgroundColor: "var(--alert-okbuttoncolor)" } },
					{ key: "reject", label: { tc: "拒絕", sc: "拒绝", en: "Reject" }[lang], ngStyle: { backgroundColor: "var(--alert-cancelbuttoncolor)" } }
				]],
				templateContent: this.customEleTemplate,
				uiVersion: 1
			}).then((result: string) => {
				this.isShowingEulaPopup = false;
				if (result == "agree") {
					this.datas.setPersonalSetting('okaEulaVer', this.okaEulaVer);
				} else {
					this.userMenu.logoutClick();
				}
			});
		});
	}

}
